import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 1,
  class: "spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ABEventsDetails = _resolveComponent("ABEventsDetails")!
  const _component_service_details = _resolveComponent("service-details")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      ($setup.isAB4User && ($setup.isAB3Service || $setup.isAB4Service))
        ? (_openBlock(), _createBlock(_component_ion_header, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_grid, {
                class: "ion-no-padding",
                fixed: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_buttons, { slot: "start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_back_button, { "default-href": "/home" })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => [
                              ($setup.loading)
                                ? (_openBlock(), _createElementBlock("h2", _hoisted_1, "..."))
                                : (_openBlock(), _createElementBlock("h2", _hoisted_2, [
                                    _createElementVNode("b", null, _toDisplayString($setup.getServiceName()), 1)
                                  ]))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_ion_spinner)
          ]))
        : (_openBlock(), _createBlock(_component_ion_content, { key: 2 }, {
            default: _withCtx(() => [
              ($setup.isAB4User && $setup.isAB3Service)
                ? (_openBlock(), _createBlock(_component_ion_grid, {
                    key: 0,
                    fixed: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { lines: "full" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                  _createElementVNode("h2", null, [
                                    _createElementVNode("b", null, "Scope of services")
                                  ], -1)
                                ])),
                                _: 1,
                                __: [1]
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, { lines: "full" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                  _createElementVNode("p", null, "1 lecture for F3 students and their parents", -1)
                                ])),
                                _: 1,
                                __: [2]
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, { lines: "full" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => _cache[3] || (_cache[3] = [
                                  _createElementVNode("p", null, "7 months of AchieveBot usage offered to all participating students", -1)
                                ])),
                                _: 1,
                                __: [3]
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, { lines: "full" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                  _createElementVNode("p", null, "Review meeting after report submission", -1)
                                ])),
                                _: 1,
                                __: [4]
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : ($setup.isAB4User && $setup.isAB4Service)
                  ? (_openBlock(), _createBlock(_component_ion_grid, {
                      key: 1,
                      fixed: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, { lines: "full" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                                    _createElementVNode("h2", null, [
                                      _createElementVNode("b", null, "Scope of services")
                                    ], -1)
                                  ])),
                                  _: 1,
                                  __: [5]
                                }),
                                ($setup.userSchoolAB4Intakes.length > 0)
                                  ? (_openBlock(), _createBlock(_component_ion_select, {
                                      key: 0,
                                      fill: "outline",
                                      interface: "popover",
                                      slot: "end",
                                      style: {"min-width":"130px"},
                                      modelValue: $setup.selectedIntakeId,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedIntakeId) = $event))
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userSchoolAB4Intakes, (intake) => {
                                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                                            key: intake.id,
                                            value: intake.id
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(intake.academicYear), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, { lines: "full" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                                    _createElementVNode("p", null, "2 lessons for F4 students (Duration and number of students as specified below)", -1)
                                  ])),
                                  _: 1,
                                  __: [6]
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, { lines: "full" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                                    _createElementVNode("p", null, "7 months of AchieveBot usage offered to all participating students", -1)
                                  ])),
                                  _: 1,
                                  __: [7]
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, { lines: "full" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                                    _createElementVNode("p", null, "Review meeting after report submission", -1)
                                  ])),
                                  _: 1,
                                  __: [8]
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card, { class: "no-border-card" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, { lines: "none" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                                    _createElementVNode("h2", null, [
                                      _createElementVNode("b", null, "Proposed arrangement")
                                    ], -1)
                                  ])),
                                  _: 1,
                                  __: [9]
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, { lines: "none" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                                    _createElementVNode("p", null, "Lesson 1", -1)
                                  ])),
                                  _: 1,
                                  __: [10]
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ABEventsDetails, {
                          targetAnchorEvId: "abs-session1",
                          ab4IntakeId: $setup.selectedIntakeId,
                          suggestedDuration: 80
                        }, null, 8, ["ab4IntakeId"]),
                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "divider" }, null, -1)),
                        _createVNode(_component_ion_card, { class: "no-border-card" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, { lines: "none" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                                    _createElementVNode("p", null, "Lesson 2", -1)
                                  ])),
                                  _: 1,
                                  __: [11]
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ABEventsDetails, {
                          targetAnchorEvId: "abs-session2",
                          ab4IntakeId: $setup.selectedIntakeId,
                          suggestedDuration: 40
                        }, null, 8, ["ab4IntakeId"])
                      ]),
                      _: 1,
                      __: [12]
                    }))
                  : (_openBlock(), _createBlock(_component_service_details, {
                      key: 2,
                      serviceId: $setup.serviceId,
                      userId: $setup.userId,
                      isSurvey: $setup.isSurvey()
                    }, null, 8, ["serviceId", "userId", "isSurvey"]))
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}